"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequiredCodesForNumberFormatterLocaleData = exports.genericGetDateFormat = void 0;
var _intlDatetimeformat = require("@formatjs/intl-datetimeformat");
var _localeFallback = require("../localeFallback");
var _utils = require("../utils");
var getRequiredCodesForNumberFormatterLocaleData = exports.getRequiredCodesForNumberFormatterLocaleData = function getRequiredCodesForNumberFormatterLocaleData(locale) {
  var resolvedLocale = (0, _localeFallback.resolveLocale)(locale);
  if (resolvedLocale === (0, _localeFallback.resolveLocale)('cnr') || resolvedLocale === 'cnr') {
    return ['sr', 'sr-latn'];
  }
  return [resolvedLocale];
};
var resolveConstructor = function resolveConstructor(locale, constructor) {
  var actualLocale = (0, _localeFallback.resolveLocale)(locale);
  var DateTimeFormatPolyfill = constructor;
  try {
    if (Intl.DateTimeFormat.supportedLocalesOf(actualLocale).length > 0 && !(0, _localeFallback.shouldPolyfill)(actualLocale)) {
      return function (options) {
        return new Intl.DateTimeFormat(actualLocale, options);
      };
    }
  } catch (_unused) {
    return function (options) {
      return new Intl.DateTimeFormat('en-US', options);
    };
  }
  if (DateTimeFormatPolyfill.availableLocales.has(actualLocale)) {
    return function (options) {
      return new DateTimeFormatPolyfill(actualLocale, options);
    };
  }
  (0, _utils.verifySupport)();
  return function (options) {
    return new Intl.DateTimeFormat('en-US', options);
  };
};
var wereTimezonesAdded = false;
var genericGetDateFormat = exports.genericGetDateFormat = function genericGetDateFormat(locale, timezones, localeData) {
  if (!_intlDatetimeformat.DateTimeFormat.availableLocales.has(locale) && localeData) {
    _intlDatetimeformat.DateTimeFormat.__addLocaleData(localeData);
  }
  if (!wereTimezonesAdded && timezones) {
    _intlDatetimeformat.DateTimeFormat.__addTZData(timezones);
    wereTimezonesAdded = true;
  }
  return resolveConstructor(locale, _intlDatetimeformat.DateTimeFormat);
};
//# sourceMappingURL=localeDataUtils.js.map